




import Vue from 'vue'
import Component from 'vue-class-component'
import LoginForm from '@/components/form/LoginForm.vue'

@Component({
    components: {
        LoginForm
    }
})
export default class Auth extends Vue {

}
